import axios from './axios-defaults';

import appConfig from '../app.config';
import requestInterceptor from './auth-request-interceptor';
import responseInterceptor from './auth-response-interceptor';

const httpClient = axios.create({
  baseURL: appConfig.tmsApiRootUrl,
});

httpClient.interceptors.request.use(requestInterceptor);
httpClient.interceptors.response.use(
  (response) => responseInterceptor.successResponseInterceptor(response),
  responseInterceptor.errorResponseInterceptor,
);

export default httpClient;
